import { ApiTags, rootApi } from "../../../../services/rootApi";

export interface ICookie {
  studentId: string;
  deviceId: string;
  message: string;
  status: number;
}

const TAG = ApiTags.Service;
const getTag = (entity: ICookie) => entity ? [{ type: TAG, id: entity.deviceId }, TAG] : [TAG];

const cookieApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    updateCookie: builder.mutation<ICookie, { deviceId: string; rollNo: string; deviceType: string }>({
      query: ({ deviceId, rollNo, deviceType }) => {
        return `/Cookie/cookie(${rollNo})/(${deviceType})/(${deviceId})`;
      }
    }),

    getCookiesDeviceId: builder.query<ICookie, { contactId: string; }>({
      query: ({ contactId }) => {
        return `/Cookie/device/(${contactId})`;
      },
      providesTags: (result) => result ? getTag(result) : [TAG],
    }),
  }),
});

export const {
  useGetCookiesDeviceIdQuery,
  useLazyGetCookiesDeviceIdQuery,
  useUpdateCookieMutation
} = cookieApi;
